import React from "react";
import { ErrorMessage, Field, Formik } from "formik";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { authenticationService } from "../../../services";
import { LoadingSpinner } from "../../../components/common/Loading/LoadingSpinner";

interface LoginModalProps {
    show: boolean;
    email: string;
}

export const LoginModal: React.FC<LoginModalProps> = ({ show, email }) => {
    const navigate = useNavigate();

    const handleSubmit = (
        { username, password }: { username: string; password: string },
        { setStatus, setSubmitting }: any
    ) => {
        setStatus();
        authenticationService.login(username, password).then(
            (user) => {
                navigate("/invitations", { replace: true });
            },
            (error) => {
                setSubmitting(false);
                setStatus(error);
            }
        );
    };

    return (
        <Modal centered show={show} backdrop="static" keyboard={false}>
            <Formik
                initialValues={{
                    username: email,
                    password: "",
                }}
                validationSchema={Yup.object().shape({
                    username: Yup.string().required("Username is required"),
                    password: Yup.string().required("Password is required"),
                })}
                onSubmit={handleSubmit}
            >
                {({
                    errors,
                    status,
                    touched,
                    isSubmitting,
                    handleSubmit,
                }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <Modal.Header>
                            <Modal.Title>Login</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form.Group
                                as={Row}
                                className="mb-3"
                                controlId="username"
                            >
                                <Form.Label column sm={3}>
                                    Username <span style={{ color: 'red' }}>*</span>
                                </Form.Label>
                                <Col sm={9}>
                                    <Field
                                        name="username"
                                        disabled={true}
                                        type="text"
                                        className={
                                            "form-control" +
                                            (errors.username && touched.username
                                                ? " is-invalid"
                                                : "")
                                        }
                                    />
                                    <ErrorMessage
                                        name="username"
                                        component="div"
                                        className="invalid-feedback"
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group
                                as={Row}
                                className="mb-3"
                                controlId="password"
                            >
                                <Form.Label column sm={3}>
                                    Password <span style={{ color: 'red' }}>*</span>
                                </Form.Label>
                                <Col sm={9}>
                                    <Field
                                        name="password"
                                        type="password"
                                        className={
                                            "form-control" +
                                            (errors.password && touched.password
                                                ? " is-invalid"
                                                : "")
                                        }
                                    />
                                    <ErrorMessage
                                        name="password"
                                        component="div"
                                        className="invalid-feedback"
                                    />
                                </Col>
                            </Form.Group>
                            {status && (
                                <div className={"alert alert-danger"}>
                                    {status}
                                </div>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="form-group">
                                <Button
                                    variant="primary"
                                    disabled={isSubmitting}
                                    type="submit"
                                >
                                    {isSubmitting ? (
                                        <LoadingSpinner text="Loading..." />
                                    ) : (
                                        "Sign In"
                                    )}
                                </Button>
                            </div>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};
